import React from 'react'
import { ReactComponent as PGACoachIcon } from 'images/pga-coach-icon.svg'
import { ReactComponent as JRLLogoIcon } from 'images/jrl-logo-icon.svg'
import SchoolOutlinedIcon from 'components/material-symbol/icons/School'

const brandOptions = [
  {
    label: 'PGA Coach',
    path: '/pga-coach',
    logo: <PGACoachIcon />,
  },
  {
    label: 'PGA Jr. League',
    path: '/junior-league',
    logo: <JRLLogoIcon />,
  },
  {
    label: 'PGA Coach Training',
    path: 'https://pgacoach.lightspeedvt.com/',
    external: true,
    logo: <SchoolOutlinedIcon style={{ color: '#00234B' }} />,
  },
]

export default brandOptions
